import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'

const AccessPremiumContentDialog: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Dialog name="access_premium_content" maxWidth={364} title={t('content.accessPremiumContent')}>
      <DialogBody />
    </Dialog>
  )
}

export default AccessPremiumContentDialog

const DialogBody: React.FC = () => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)
  const session = useSession()

  // Admin
  if (session.isSiteAdmin()) {
    return (
      <>
        <p className="mb-3">{t('content.addPremiumContentDesc')}</p>
        <Button
          variant="primary"
          className="text-md px-2 py-1.5 float-right mt-2"
          onClick={() => {
            window.open('https://www.noteflight.com/commerce/purchase_learn', '_blank')
            closeDialog('access_premium_content')
          }}>
          {t('action.purchasePremiumContent')}
        </Button>
      </>
    )
  }

  // Teacher
  if (session.isSiteTeacher()) {
    return (
      <>
        <p className="mb-3">{t('content.addPremiumContentDesc')}</p>
        <p className="mb-3">
          <Trans i18nKey="content.addPremiumContentDesc_teacher">
            Talk to your site’s admin to purchase Premium Content. If your site has Premium Content,
            manage access in Manage Site &gt;
            <a
              title="addons"
              className="orange-link"
              href={`/groups#/group/${session.communityGroup?.id}/addons`}>
              Manage Add-Ons
            </a>
          </Trans>
        </p>
      </>
    )
  }

  // Student
  if (session.isSiteStudent())
    return <p className="mb-3">{t('content.addPremiumContentDesc', { context: 'student' })}</p>

  return null
}
